import { Injectable } from '@angular/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { FormState } from '../form-state';
import { FormStateHandler } from './form-state-handler';

export interface DataNotFoundContext {
    message: string;
    action(): void;
}

@Injectable({providedIn: 'root'})
export class DataNotFoundHandler extends FormStateHandler<DataNotFoundContext> {
    public constructor(public readonly toastService: ToastService) {
        super();
    }

    protected get formState(): FormState {
        return FormState.DataNotFound;
    }

    protected handle(ctx: DataNotFoundContext): void {
        this.toastService.showAsync({
            type: 'error',
            text: ctx.message,
        });
        ctx.action();
    }
}
